<template>
  <div class="header">
    <!-- 手机版本的导航栏 -->
    <span
      class="glyphicon glyphicon-menu-left arror"
      @click="goBack"
      style="font-size: 24px"
    ></span>
    <span
      class="glyphicon glyphicon-refresh arror"
      @click="refresh"
      style="font-size: 20px; left: 45px"
    ></span>
    <p>{{ $store.state.banner }}</p>

    <!-- <span @click="i18n()" class="i18n hidden">i18n</span>
    <div class="clearfix"></div>-->

    <!-- <span class="glyphicon glyphicon-search search" @click="goTo('/Search')"></span> -->

    <span
      v-if="$store.state.isLogin"
      @click="goToChat()"
      class="pull-right text-primary"
      style="padding: 15px; position: absolute; right: 90px; cursor: pointer;top:0px"
    >
      <i class="fa fa-bell" aria-hidden="true"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {};
  },
  mounted: function () {},
  methods: {
    goTo: function (_path) {
      this.$router.push({
        path: _path,
      });
    },
    goBack: function () {
      this.$router.back(-1);
    },
    refresh: function () {
      location.reload();
    },
    goToChat: function () {
      if (myutil.hasOwnProperty("thirdChatUrl")) {
        this.$router.push({
          path: "/Chat2",
        });
      } else {
        this.$router.push({
          path: "/Chat",
          query: {
            token: this.$store.state.token,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.i18n {
  position: absolute;
  top: 16px;
  right: 40px;
}
.arror {
  position: absolute;
  top: 17px;
  left: 10px;
  color: #333;
}
.search {
  position: absolute;
  right: 10px;
  top: 17px;
  color: #333;
}
.header {
  height: 50px;
  width: 100%;
  // background: #525358;
  background: #fff;
  position: fixed;
  top: 0;
  z-index: 99;
  p {
    color: #333;
    font-weight: bold;
    line-height: 50px;
    font-size: 110%;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/Header.vue